module.exports = __webpack_public_path__ + "static/map-cf043d11e0a0980ecc1f107b63e3fe08.png";